<div *adaptLoading="isBusy">
    @if (!careerValuationsChartData.length && !showGrid) {
        No Career Valuation has been recorded.
    }

    @if (careerValuationsChartData.length > 0) {
        <div class="chart-wrapper mb-3">
            <dx-chart [dataSource]="careerValuationsChartData"
                      [pathModified]="true"
                      [palette]="palette"
                      (onPointClick)="onPointClick($event)">
                <!-- Options -->
                <dxo-chart-argument-axis type="discrete">
                    <dxo-chart-grid [opacity]="0.2"
                                    [visible]="true"></dxo-chart-grid>
                    <dxo-chart-minor-grid [visible]="false"></dxo-chart-minor-grid>
                    <dxo-chart-label [visible]="false"></dxo-chart-label>
                    @for (range of stakeholderRange; track range) {
                        <dxi-chart-strip [startValue]="range.start"
                                         [endValue]="range.end"
                                         color="#f2f2f2">
                            <dxo-chart-label text="Recorded as Stakeholder">
                                <dxo-chart-font color="gray"></dxo-chart-font>
                            </dxo-chart-label>
                        </dxi-chart-strip>
                    }
                    <dxo-chart-strip-style>
                        <dxo-chart-label>
                            <dxo-chart-font size="12"></dxo-chart-font>
                        </dxo-chart-label>
                    </dxo-chart-strip-style>
                </dxo-chart-argument-axis>
                <dxi-chart-value-axis visualRangeUpdateMode="keep"
                                      [maxValueMargin]="0.001"
                                      [tickInterval]="25"
                                      [minorTickInterval]="12.5"
                                      [visualRange]="[0, 100]">
                    <dxo-chart-minor-tick [visible]="true"></dxo-chart-minor-tick>
                    <dxo-chart-label [visible]="true"></dxo-chart-label>
                </dxi-chart-value-axis>
                <dxo-chart-tooltip [enabled]="true"
                                   [customizeTooltip]="customiseTooltip"></dxo-chart-tooltip>
                <dxo-chart-legend [visible]="responsiveService.currentBreakpoint.isDesktopSize"></dxo-chart-legend>
                <dxo-chart-zoom-and-pan argumentAxis="both"></dxo-chart-zoom-and-pan>
                <!-- Series -->
                @for (category of categories; track category; let i = $index) {
                    <dxi-chart-series [name]="category.name"
                                      type="stackedbar"
                                      [valueField]="'cat' + i"
                                      argumentField="creationDate"
                                      tagField="careerValuation"> </dxi-chart-series>
                }
                <dxi-chart-series name="Overall"
                                  type="line"
                                  valueField="value"
                                  argumentField="creationDate"
                                  tagField="careerValuation"
                                  [width]="0.5"> </dxi-chart-series>
            </dx-chart>
        </div>
    }

    @if (showGrid) {
        <dx-data-grid [dataSource]="careerValuations"
                      [wordWrapEnabled]="true"
                      [columnAutoWidth]="true"
                      [rowAlternationEnabled]="true"
                      [hoverStateEnabled]="true"
                      noDataText="No Career Valuations recorded"
                      [showRowLines]="true"
                      [showBorders]="true"
                      (onInitialized)="onGridInitialized($event)">
            <!-- Options -->
            <dxo-data-grid-pager [showPageSizeSelector]="true"></dxo-data-grid-pager>
            <dxo-data-grid-paging [pageSize]="5"></dxo-data-grid-paging>
            <dxo-data-grid-export [enabled]="false"
                                  fileName="Career Valuation history"></dxo-data-grid-export>
            <!-- Columns -->
            <dxi-data-grid-column caption="Date"
                                  dataField="creationDate"
                                  dataType="date"
                                  [format]="shortDateFormat"
                                  sortOrder="desc"
                                  [sortIndex]="0"
                                  [width]="100"> </dxi-data-grid-column>
            <dxi-data-grid-column caption="Value"
                                  dataField="extensions.actualTotal"
                                  dataType="number"
                                  [customizeText]="careerValuationUiService.customiseValueCellText"
                                  [cellTemplate]="careerValuationUiService.getValueCellTemplate"
                                  [width]="120"></dxi-data-grid-column>
            <dxi-data-grid-column caption="Notes"
                                  dataType="string"
                                  [encodeHtml]="false"
                                  cellTemplate="richTextTemplate"
                                  [calculateCellValue]="calculateCellValue"
                                  [visible]="notesColumnVisible || allColumnsVisible"> </dxi-data-grid-column>
            @for (category of categories; track category; let i = $index) {
                <dxi-data-grid-column [name]="category.name + ' Score'"
                                      [caption]="category.name + ' Score'"
                                      [dataField]="'categoryValues[' + i + '].extensions.score'"
                                      dataType="string"
                                      [visible]="allColumnsVisible"></dxi-data-grid-column>
                <dxi-data-grid-column [name]="category.name"
                                      [caption]="category.name"
                                      [dataField]="'categoryValues[' + i + '].notes'"
                                      dataType="string"
                                      [encodeHtml]="false"
                                      cellTemplate="richTextTemplate"
                                      [visible]="allColumnsVisible"> </dxi-data-grid-column>
            }
            <!-- Templates -->
            <div *dxTemplate="let item of 'richTextTemplate'">
                <div [froalaView]="item.value"></div>
            </div>
        </dx-data-grid>
    }
</div>
